import React, {Component,Fragment} from 'react';
import { connect } from "react-redux";
/*
    Importing AlertDialogSlide for sliding Modal Window
*/
import AlertDialogSlide from "./AlertDialogSlide";

class Footer extends Component {
  render() {
    let disclaimer = <p style={{fontSize:'13px'}}>Product availability varies by state. To see loan products offered in your state of residence, please visit our <AlertDialogSlide linkText="Rates and Terms" tip="ratesterms"/> page.</p>;

    let ohdisclaimer = <p style={{fontSize:'13px'}}>MoneyKey-OH is licensed as a Credit Services Organization (CSO) by the Ohio Department of Financial Institutions, Department of Commerce: CS.900134.000.</p>;
    let txdisclaimer = <p style={{fontSize:'13px'}}>MoneyKey-TX, Inc. is licensed as a Credit Access Business (CAB), License No. 16641-62815, by the Office of the Consumer Credit Commissioner and registered as a Credit Services Organization (CSO), Registration No. 20110150, by the State of Texas.</p>;
    let cabdisclaimer = <p style={{fontSize:'13px'}}>All loans for which MoneyKey acts as a CSO and/or CAB are funded by an unaffiliated third-party lender and serviced by MoneyKey.</p>;
    let cadisclaimer = <p style={{fontSize:'13px'}}>In the State of California, MoneyKey - CA, Inc. is licensed by the Department of Business Oversight pursuant to a California Finance Lenders Law License, License No. 60DBO43590 and a California Deferred Deposit Transaction Law License, License No.1004516.</p>;

    let trustpilot = <p style={{fontSize:'13px'}}>Reviews and any ratings referenced are based on the TrustPilot review, reviews reflect individuals’ opinions and may not be illustrative of all individual experiences with MoneyKey .</p>;
    let disclaimerother=<Fragment>
                          <p style={{fontSize:'13px'}}><sup>1</sup>Not all applications are approved; duration of approval process may vary.</p>
                          <p style={{fontSize:'13px'}}><sup>2</sup> The date and time funds are made available to you are subject to your bank&#39;s policies</p>
                        </Fragment>;
    return (
      <Fragment>
        <div id="shortfooter">
          <div className="dashfooter text-center">
            <h4>We&#39;re here to help</h4>
            <p>Our Customer Care team is here to give you a hand 7 days a week. Contact us by email or phone.</p>
            <div className="row">
              <div className="col-xs-6 text-center">
                <a href="mailto:customercare@moneykey.com">
                  <div className="circlebg footeremailicon">
                    <img className="style-svg" src="/images/svg/emailicon.svg" alt="emailicon" />
                  </div>
                </a>
              </div>
              <div className="col-xs-6 text-center">
                <a href="tel:18662551668">
                  <div className="circlebg footerphoneicon">
                    <img className="style-svg" src="/images/svg/phoneicon.svg" alt="phoneicon" />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="container padtop50">
            <div className="row">
              <div className="col-xs-12 text-center">
                {disclaimer}

                {this.props.stt === "OH" && ohdisclaimer}
                {this.props.stt === "OH" && cabdisclaimer}
                {this.props.stt === "TX" && txdisclaimer}
                {this.props.stt === "TX" && cabdisclaimer}
                {this.props.stt === "CA" && cadisclaimer}

                {this.props.pagename === "Apply Now" && trustpilot}
                {this.props.pagename === "Congratulations" && trustpilot}

                {this.props.pagename === "Apply Now" && disclaimerother}
                {this.props.currentstep >= 8 && disclaimerother}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
    stt: state.FormReducer.stt,
    currentstep: state.FormReducer.currentstep,
    pagename: state.FormReducer.pagename,
});

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/partials/Footer.js